export const ADMIN_SECTIONS = [
    { to: '/admin/categories', title: 'Категории', hint: 'Структура меню' },
    { to: '/admin/products', title: 'Продукты', hint: 'Товары меню' },
    { to: '/admin/modifiers', title: 'Модификаторы', hint: 'Дополнения к товарам и связи' },
    { to: '/admin/orders', title: 'Заказы', hint: 'Статусы и список' },
    { to: '/admin/menus', title: 'Меню', hint: 'Наборы блюд для ресторанов' },
    { to: '/admin/restaurants', title: 'Рестораны', hint: 'Адреса и привязка к меню' },
    { to: '/admin/users', title: 'Пользователи', hint: 'Клиенты и адреса' },
    { to: '/admin/bonuses', title: 'Бонусы', hint: 'Счета и операции' },
    { to: '/admin/promotions', title: 'Промокоды', hint: 'Скидки и промокоды' },
    { to: '/admin/combos', title: 'Комбо-наборы', hint: 'Набор за фиксированную цену' },
    { to: '/admin/configs', title: 'Конфиги', hint: 'Динамические параметры' },
    { to: '/admin/media', title: 'Медиа', hint: 'Изображения и файлы' },
    { to: '/admin/metrics', title: 'Метрики', hint: 'Оборот по точкам и KPI' },
];
